'use client'

// src/api/queries/where.ts
var commonWhere = {
  visibility_not: "private",
  OR: [
    { schedule: { closeDateTime_exists: false } },
    // Using new Date() alone would be accutare
    // but it means the payload body will change every second
    // which will kill the cache implementation in CF
    { schedule: { closeDateTime_gte: new Date((/* @__PURE__ */ new Date()).setMinutes(0, 0, 0)) } }
  ]
};

export {
  commonWhere
};
//# sourceMappingURL=chunk-N55STAST.mjs.map